"use strict";

function t() {
  function e(e) {
    return "number" != typeof e && "string" != typeof e ? this.makeError("string") : ("string" != typeof e && (e = String(e)), e = e.replace(/\D+/g, ""), function (e) {
      return function (t) {
        for (var r = t ? t.length : 0, n = 1, i = 0; r--;) {
          i += (n ^= 1) ? e[t[r]] : parseInt(t[r], 10);
        }

        return 0 == i % 10 && 0 < i;
      };
    }([0, 2, 4, 6, 8, 1, 3, 5, 7, 9])(e) || this.makeError("luhn"));
  }

  function t(e) {
    return "string" != typeof e ? this.makeError("string") : (e = e.toLowerCase(), !!w.test(e) || this.makeError("mac"));
  }

  function r(e, t) {
    if ("string" != typeof e) return this.makeError("string");
    if (e = e.toLowerCase(), !M.test(e)) return this.makeError("uuid");
    var r = 0 | e.charAt(14);
    if (t.version && t.version !== r) return this.makeError("uuidVersion", t.version, r);

    switch (r) {
      case 1:
      case 2:
        return !0;

      case 3:
      case 4:
      case 5:
        return -1 !== ["8", "9", "a", "b"].indexOf(e.charAt(19)) || this.makeError("uuid");
    }
  }

  function n(e) {
    return "string" != typeof e ? this.makeError("string") : !!j.test(e) || this.makeError("url");
  }

  function i(e, t) {
    if ("string" != typeof e) return this.makeError("string");
    var r = e.length;
    return !1 === t.empty && 0 === r ? this.makeError("stringEmpty") : null != t.min && r < t.min ? this.makeError("stringMin", t.min, r) : null != t.max && r > t.max ? this.makeError("stringMax", t.max, r) : null != t.length && r !== t.length ? this.makeError("stringLength", t.length, r) : null == t.pattern || (r = "string" == typeof t.pattern ? new RegExp(t.pattern, t.patternFlags) : t.pattern).test(e) ? null != t.contains && -1 === e.indexOf(t.contains) ? this.makeError("stringContains", t.contains, e) : null != t.enum && -1 === t.enum.indexOf(e) ? this.makeError("stringEnum", t.enum, e) : !0 !== t.numeric || O.test(e) ? !0 !== t.alpha || _.test(e) ? !0 !== t.alphanum || A.test(e) ? !(!0 === t.alphadash && !T.test(e)) || this.makeError("stringAlphadash", "An alphadash string", e) : this.makeError("stringAlphanum", "An alphanumeric string", e) : this.makeError("stringAlpha", "An alphabetic string", e) : this.makeError("stringNumeric", "A numeric string", e) : this.makeError("stringPattern", r, e);
  }

  function a(e, t) {
    if ("object" != typeof e || null === e || Array.isArray(e)) return this.makeError("object");

    if (!0 === t.strict && t.props) {
      t = Object.keys(t.props);
      var r = [];
      e = Object.keys(e);

      for (var n = 0; n < e.length; n++) {
        -1 === t.indexOf(e[n]) && r.push(e[n]);
      }

      if (0 !== r.length) return this.makeError("objectStrict", void 0, r.join(", "));
    }

    return !0;
  }

  function o(e, t) {
    return !0 === t.convert && "number" != typeof e && (e = Number(e)), "number" != typeof e || isNaN(e) || !isFinite(e) ? this.makeError("number") : null != t.min && e < t.min ? this.makeError("numberMin", t.min, e) : null != t.max && e > t.max ? this.makeError("numberMax", t.max, e) : null != t.equal && e !== t.equal ? this.makeError("numberEqual", t.equal, e) : null != t.notEqual && e === t.notEqual ? this.makeError("numberNotEqual", t.notEqual) : !0 === t.integer && 0 != e % 1 ? this.makeError("numberInteger", e) : !0 === t.positive && 0 >= e ? this.makeError("numberPositive", e) : !(!0 === t.negative && 0 <= e) || this.makeError("numberNegative", e);
  }

  function s(e) {
    return "function" == typeof e || this.makeError("function");
  }

  function u(e) {
    return null === e || void 0 === e || this.makeError("forbidden");
  }

  function l(e, t) {
    return null == t.values || -1 !== t.values.indexOf(e) || this.makeError("enumValue", t.values, e);
  }

  function f(e, t) {
    return "string" != typeof e ? this.makeError("string") : !!("precise" == t.mode ? S : x).test(e) || this.makeError("email");
  }

  function c(e, t) {
    return !0 !== t.convert || e instanceof Date || (e = new Date(e)), e instanceof Date && !isNaN(e.getTime()) || this.makeError("date");
  }

  function h(e, t) {
    return t.check.call(this, e, t);
  }

  function p(e, t) {
    return !0 === t.convert && "boolean" != typeof e && (1 === e || 0 === e || "true" === e || "false" === e || "1" === e || "0" === e || "on" === e || "off" === e) || "boolean" == typeof e || this.makeError("boolean");
  }

  function m(e, t) {
    if (!Array.isArray(e)) return this.makeError("array");
    var r = e.length;
    if (!1 === t.empty && 0 === r) return this.makeError("arrayEmpty");
    if (null != t.min && r < t.min) return this.makeError("arrayMin", t.min, r);
    if (null != t.max && r > t.max) return this.makeError("arrayMax", t.max, r);
    if (null != t.length && r !== t.length) return this.makeError("arrayLength", t.length, r);
    if (null != t.contains && -1 === e.indexOf(t.contains)) return this.makeError("arrayContains", t.contains);
    if (null != t.enum) for (r = 0; r < e.length; r++) {
      if (-1 === t.enum.indexOf(e[r])) return this.makeError("arrayEnum", e[r], t.enum);
    }
    return !0;
  }

  function d() {
    return !0;
  }

  function y(e, t) {
    t = t || [];

    for (var r = 0; r < e.length; ++r) {
      Array.isArray(e[r]) ? y(e[r], t) : t.push(e[r]);
    }

    return t;
  }

  function g(e, t) {
    for (var r in t) {
      "object" == typeof t[r] && null !== t[r] ? (e[r] = e[r] || {}, g(e[r], t[r])) : e[r] = t[r];
    }

    return e;
  }

  function b(e) {
    return e.replace(R, function (e) {
      switch (e) {
        case '"':
        case "'":
        case "\\":
          return "\\" + e;

        case "\n":
          return "\\n";

        case "\r":
          return "\\r";

        case "\u2028":
          return "\\u2028";

        case "\u2029":
          return "\\u2029";
      }
    });
  }

  function v(y) {
    this.opts = {
      messages: E({}, k)
    }, y && E(this.opts, y), this.messages = this.opts.messages, this.messageKeys = Object.keys(this.messages), this.rules = {
      any: d,
      array: m,
      boolean: p,
      custom: h,
      date: c,
      email: f,
      enum: l,
      forbidden: u,
      function: s,
      number: o,
      object: a,
      string: i,
      url: n,
      uuid: r,
      mac: t,
      luhn: e
    }, this.cache = new Map();
  }

  var E = g,
      k = {
    required: "The '{field}' field is required!",
    string: "The '{field}' field must be a string!",
    stringEmpty: "The '{field}' field must not be empty!",
    stringMin: "The '{field}' field length must be greater than or equal to {expected} characters long!",
    stringMax: "The '{field}' field length must be less than or equal to {expected} characters long!",
    stringLength: "The '{field}' field length must be {expected} characters long!",
    stringPattern: "The '{field}' field fails to match the required pattern!",
    stringContains: "The '{field}' field must contain the '{expected}' text!",
    stringEnum: "The '{field}' field does not match any of the allowed values!",
    stringNumeric: "The '{field}' field must be a numeric string",
    stringAlpha: "The '{field}' field must be an alphabetic string",
    stringAlphanum: "The '{field}' field must be an alphanumeric string",
    stringAlphadash: "The '{field}' field must be an alphadash string",
    number: "The '{field}' field must be a number!",
    numberMin: "The '{field}' field must be greater than or equal to {expected}!",
    numberMax: "The '{field}' field must be less than or equal to {expected}!",
    numberEqual: "The '{field}' field must be equal with {expected}!",
    numberNotEqual: "The '{field}' field can't be equal with {expected}!",
    numberInteger: "The '{field}' field must be an integer!",
    numberPositive: "The '{field}' field must be a positive number!",
    numberNegative: "The '{field}' field must be a negative number!",
    array: "The '{field}' field must be an array!",
    arrayEmpty: "The '{field}' field must not be an empty array!",
    arrayMin: "The '{field}' field must contain at least {expected} items!",
    arrayMax: "The '{field}' field must contain less than or equal to {expected} items!",
    arrayLength: "The '{field}' field must contain {expected} items!",
    arrayContains: "The '{field}' field must contain the '{expected}' item!",
    arrayEnum: "The '{field} field value '{expected}' does not match any of the allowed values!",
    boolean: "The '{field}' field must be a boolean!",
    function: "The '{field}' field must be a function!",
    date: "The '{field}' field must be a Date!",
    dateMin: "The '{field}' field must be greater than or equal to {expected}!",
    dateMax: "The '{field}' field must be less than or equal to {expected}!",
    forbidden: "The '{field}' field is forbidden!",
    email: "The '{field}' field must be a valid e-mail!",
    url: "The '{field}' field must be a valid URL!",
    enumValue: "The '{field} field value '{expected}' does not match any of the allowed values!",
    object: "The '{field}' must be an Object!",
    objectStrict: "The object '{field}' contains invalid keys: '{actual}'!",
    uuid: "The {field} field must be a valid UUID",
    uuidVersion: "The {field} field must be a valid version provided",
    mac: "The {field} field must be a valid MAC address",
    luhn: "The {field} field must be a valid checksum luhn"
  },
      S = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      x = /^\S+@\S+\.\S+$/,
      O = /^-?[0-9]\d*(\.\d+)?$/,
      _ = /^[a-zA-Z]+$/,
      A = /^[a-zA-Z0-9]+$/,
      T = /^[a-zA-Z0-9_-]+$/,
      j = /^https?:\/\/\S+/,
      M = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
      w = /^((([a-f0-9][a-f0-9]+[-]){5}|([a-f0-9][a-f0-9]+[:]){5})([a-f0-9][a-f0-9])$)|(^([a-f0-9][a-f0-9][a-f0-9][a-f0-9]+[.]){2}([a-f0-9][a-f0-9][a-f0-9][a-f0-9]))$/i,
      P = /^[_$a-zA-Z][_$a-zA-Z0-9]*$/,
      R = /["'\\\n\r\u2028\u2029]/g;
  return v.prototype.validate = function (e, t) {
    return this.compile(t)(e);
  }, v.prototype.compile = function (e) {
    var t = this;

    if (Array.isArray(e)) {
      if (0 == e.length) throw Error("If the schema is an Array, must contain at least one element!");
      var r = this.compileSchemaType(e);
      return this.cache.clear(), function (e, n, i) {
        return t.checkSchemaType(e, r, n, i || null);
      };
    }

    var n = this.compileSchemaObject(e);
    return this.cache.clear(), function (e, r, i) {
      return t.checkSchemaObject(e, n, r, i || null);
    };
  }, v.prototype.compileSchemaObject = function (e) {
    var t = this;
    if (null === e || "object" != typeof e || Array.isArray(e)) throw Error("Invalid schema!");
    var r = this.cache.get(e);
    if (r) return r.cycle = !0, r;
    r = {
      cycle: !1,
      properties: null,
      compiledObjectFunction: null,
      objectStack: []
    }, this.cache.set(e, r), r.properties = Object.keys(e).filter(function (e) {
      return "$$strict" !== e;
    }).map(function (r) {
      return {
        name: r,
        compiledType: t.compileSchemaType(e[r])
      };
    });
    var n = [];
    n.push("let res;"), n.push("let propertyPath;"), n.push("const errors = [];"), !0 === e.$$strict && n.push("const givenProps = new Map(Object.keys(value).map(key => [key, true]));");

    for (var i = 0; i < r.properties.length; i++) {
      var a = r.properties[i],
          o = b(a.name),
          s = P.test(o) ? "value." + o : 'value["' + o + '"]';
      n.push('propertyPath = (path !== undefined ? path + ".' + o + '" : "' + o + '");'), Array.isArray(a.compiledType) ? n.push("res = this.checkSchemaType(" + s + ", properties[" + i + "].compiledType, propertyPath, value);") : n.push("res = this.checkSchemaRule(" + s + ", properties[" + i + "].compiledType, propertyPath, value);"), n.push("if (res !== true) {"), n.push("\tthis.handleResult(errors, propertyPath, res, properties[" + i + "].compiledType.messages);"), n.push("}"), !0 === e.$$strict && n.push('givenProps.delete("' + o + '");');
    }

    return !0 === e.$$strict && (n.push("if (givenProps.size !== 0) {"), n.push("\tthis.handleResult(errors, path || 'rootObject', this.makeError('objectStrict', undefined, [...givenProps.keys()].join(', ')), this.messages);"), n.push("}")), n.push("return errors.length === 0 ? true : errors;"), r.compiledObjectFunction = new Function("value", "properties", "path", "parent", n.join("\n")), r;
  }, v.prototype.compileSchemaType = function (e) {
    var t = this;
    return Array.isArray(e) ? (e = y(e.map(function (e) {
      return t.compileSchemaType(e);
    })), 1 == e.length ? e[0] : e) : this.compileSchemaRule(e);
  }, v.prototype.compileMessages = function (e) {
    return e.messages ? Object.assign({}, this.messages, e.messages) : this.messages;
  }, v.prototype.compileSchemaRule = function (e) {
    "string" == typeof e && (e = {
      type: e
    });
    var t = this.rules[e.type];
    if (!t) throw Error("Invalid '" + e.type + "' type in validator schema!");
    var r = this.compileMessages(e),
        n = null,
        i = null;
    return "object" === e.type && e.props ? (n = this.compileSchemaObject(e.props), i = this.checkSchemaObject) : "array" === e.type && e.items && (n = this.compileSchemaType(e.items), i = this.checkSchemaArray), {
      messages: r,
      schemaRule: e,
      ruleFunction: t,
      dataFunction: i,
      dataParameter: n
    };
  }, v.prototype.checkSchemaObject = function (e, t, r, n) {
    return t.cycle ? -1 !== t.objectStack.indexOf(e) || (t.objectStack.push(e), e = this.checkSchemaObjectInner(e, t, r, n), t.objectStack.pop(), e) : this.checkSchemaObjectInner(e, t, r, n);
  }, v.prototype.checkSchemaObjectInner = function (e, t, r, n) {
    return t.compiledObjectFunction.call(this, e, t.properties, r, n);
  }, v.prototype.checkSchemaType = function (e, t, r, n) {
    if (Array.isArray(t)) {
      for (var i = [], a = t.length, o = 0; o < a; o++) {
        var s = this.checkSchemaRule(e, t[o], r, n);
        if (!0 === s) return !0;
        this.handleResult(i, r, s, t.messages);
      }

      return i;
    }

    return this.checkSchemaRule(e, t, r, n);
  }, v.prototype.checkSchemaArray = function (e, t, r, n) {
    for (var i = [], a = e.length, o = 0; o < a; o++) {
      var s = (void 0 !== r ? r : "") + "[" + o + "]",
          u = this.checkSchemaType(e[o], t, s, e, n);
      !0 !== u && this.handleResult(i, s, u, t.messages);
    }

    return 0 === i.length || i;
  }, v.prototype.checkSchemaRule = function (e, t, r, n) {
    var i = t.schemaRule;
    return void 0 === e || null === e ? "forbidden" === i.type || !0 === i.optional || (e = [], this.handleResult(e, r, this.makeError("required"), t.messages), e) : (i = t.ruleFunction.call(this, e, i, r, n), !0 !== i ? (e = [], this.handleResult(e, r, i, t.messages), e) : null === t.dataFunction || t.dataFunction.call(this, e, t.dataParameter, r, n));
  }, v.prototype.handleResult = function (e, t, r, n) {
    var i = this;
    (Array.isArray(r) ? r : [r]).forEach(function (r) {
      r.field || (r.field = t), r.message || (r.message = i.resolveMessage(r, n[r.type])), e.push(r);
    });
  }, v.prototype.makeError = function (e, t, r) {
    return {
      type: e,
      expected: t,
      actual: r
    };
  }, v.prototype.resolveMessage = function (e, t) {
    if (void 0 === t && (t = null), null != t) {
      var r = null != e.expected ? e.expected : "",
          n = null != e.actual ? e.actual : "";
      return t.replace(/\{field\}/g, e.field).replace(/\{expected\}/g, r).replace(/\{actual\}/g, n);
    }
  }, v.prototype.add = function (e, t) {
    this.rules[e] = t;
  }, v;
}

var f = f || {};
f.scope = {}, f.ASSUME_ES5 = !1, f.ASSUME_NO_NATIVE_MAP = !1, f.ASSUME_NO_NATIVE_SET = !1, f.defineProperty = f.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, t, r) {
  e != Array.prototype && e != Object.prototype && (e[t] = r.value);
}, f.getGlobal = function (e) {
  return "undefined" != typeof window && window === e ? e : "undefined" != typeof global && null != global ? global : e;
}, f.global = f.getGlobal(this), f.SYMBOL_PREFIX = "jscomp_symbol_", f.initSymbol = function () {
  f.initSymbol = function () {}, f.global.Symbol || (f.global.Symbol = f.Symbol);
}, f.Symbol = function () {
  var e = 0;
  return function (t) {
    return f.SYMBOL_PREFIX + (t || "") + e++;
  };
}(), f.initSymbolIterator = function () {
  f.initSymbol();
  var e = f.global.Symbol.iterator;
  e || (e = f.global.Symbol.iterator = f.global.Symbol("iterator")), "function" != typeof Array.prototype[e] && f.defineProperty(Array.prototype, e, {
    configurable: !0,
    writable: !0,
    value: function value() {
      return f.arrayIterator(this);
    }
  }), f.initSymbolIterator = function () {};
}, f.arrayIterator = function (e) {
  var t = 0;
  return f.iteratorPrototype(function () {
    return t < e.length ? {
      done: !1,
      value: e[t++]
    } : {
      done: !0
    };
  });
}, f.iteratorPrototype = function (e) {
  return f.initSymbolIterator(), e = {
    next: e
  }, e[f.global.Symbol.iterator] = function () {
    return this;
  }, e;
}, f.iteratorFromArray = function (e, t) {
  f.initSymbolIterator(), e instanceof String && (e += "");
  var r = 0,
      n = {
    next: function next() {
      if (r < e.length) {
        var i = r++;
        return {
          value: t(i, e[i]),
          done: !1
        };
      }

      return n.next = function () {
        return {
          done: !0,
          value: void 0
        };
      }, n.next();
    }
  };
  return n[Symbol.iterator] = function () {
    return n;
  }, n;
}, f.polyfill = function (e, t) {
  if (t) {
    var r = f.global;
    e = e.split(".");

    for (var n = 0; n < e.length - 1; n++) {
      var i = e[n];
      i in r || (r[i] = {}), r = r[i];
    }

    (t = t(n = r[e = e[e.length - 1]])) != n && null != t && f.defineProperty(r, e, {
      configurable: !0,
      writable: !0,
      value: t
    });
  }
}, f.polyfill("Array.prototype.keys", function (e) {
  return e || function () {
    return f.iteratorFromArray(this, function (e) {
      return e;
    });
  };
}, "es6", "es3"), f.checkEs6ConformanceViaProxy = function () {
  try {
    var e = {},
        t = Object.create(new f.global.Proxy(e, {
      get: function get(r, n, i) {
        return r == e && "q" == n && i == t;
      }
    }));
    return !0 === t.q;
  } catch (e) {
    return !1;
  }
}, f.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS = !1, f.ES6_CONFORMANCE = f.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS && f.checkEs6ConformanceViaProxy(), f.makeIterator = function (e) {
  f.initSymbolIterator();
  var t = e[Symbol.iterator];
  return t ? t.call(e) : f.arrayIterator(e);
}, f.owns = function (e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}, f.polyfill("WeakMap", function (e) {
  function t(e) {
    if (this.id_ = (a += Math.random() + 1).toString(), e) {
      f.initSymbol(), f.initSymbolIterator(), e = f.makeIterator(e);

      for (var t; !(t = e.next()).done;) {
        t = t.value, this.set(t[0], t[1]);
      }
    }
  }

  function r(e) {
    f.owns(e, i) || f.defineProperty(e, i, {
      value: {}
    });
  }

  function n(e) {
    var t = Object[e];
    t && (Object[e] = function (e) {
      return r(e), t(e);
    });
  }

  if (f.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
    if (e && f.ES6_CONFORMANCE) return e;
  } else if (function () {
    if (!e || !Object.seal) return !1;

    try {
      var t = Object.seal({}),
          r = Object.seal({}),
          n = new e([[t, 2], [r, 3]]);
      return 2 == n.get(t) && 3 == n.get(r) && (n.delete(t), n.set(r, 4), !n.has(t) && 4 == n.get(r));
    } catch (e) {
      return !1;
    }
  }()) return e;

  var i = "$jscomp_hidden_" + Math.random();
  n("freeze"), n("preventExtensions"), n("seal");
  var a = 0;
  return t.prototype.set = function (e, t) {
    if (r(e), !f.owns(e, i)) throw Error("WeakMap key fail: " + e);
    return e[i][this.id_] = t, this;
  }, t.prototype.get = function (e) {
    return f.owns(e, i) ? e[i][this.id_] : void 0;
  }, t.prototype.has = function (e) {
    return f.owns(e, i) && f.owns(e[i], this.id_);
  }, t.prototype.delete = function (e) {
    return !(!f.owns(e, i) || !f.owns(e[i], this.id_)) && delete e[i][this.id_];
  }, t;
}, "es6", "es3"), f.MapEntry = function () {}, f.polyfill("Map", function (e) {
  function t() {
    var e = {};
    return e.previous = e.next = e.head = e;
  }

  function r(e, t) {
    var r = e.head_;
    return f.iteratorPrototype(function () {
      if (r) {
        for (; r.head != e.head_;) {
          r = r.previous;
        }

        for (; r.next != r.head;) {
          return r = r.next, {
            done: !1,
            value: t(r)
          };
        }

        r = null;
      }

      return {
        done: !0,
        value: void 0
      };
    });
  }

  function n(e, t) {
    var r = t && typeof t;
    "object" == r || "function" == r ? a.has(t) ? r = a.get(t) : (r = "" + ++o, a.set(t, r)) : r = "p_" + t;
    var n = e.data_[r];
    if (n && f.owns(e.data_, r)) for (e = 0; e < n.length; e++) {
      var i = n[e];
      if (t !== t && i.key !== i.key || t === i.key) return {
        id: r,
        list: n,
        index: e,
        entry: i
      };
    }
    return {
      id: r,
      list: n,
      index: -1,
      entry: void 0
    };
  }

  function i(e) {
    if (this.data_ = {}, this.head_ = t(), this.size = 0, e) {
      e = f.makeIterator(e);

      for (var r; !(r = e.next()).done;) {
        r = r.value, this.set(r[0], r[1]);
      }
    }
  }

  if (f.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
    if (e && f.ES6_CONFORMANCE) return e;
  } else if (function () {
    if (f.ASSUME_NO_NATIVE_MAP || !e || "function" != typeof e || !e.prototype.entries || "function" != typeof Object.seal) return !1;

    try {
      var t = Object.seal({
        x: 4
      }),
          r = new e(f.makeIterator([[t, "s"]]));
      if ("s" != r.get(t) || 1 != r.size || r.get({
        x: 4
      }) || r.set({
        x: 4
      }, "t") != r || 2 != r.size) return !1;
      var n = r.entries(),
          i = n.next();
      return !i.done && i.value[0] == t && "s" == i.value[1] && !((i = n.next()).done || 4 != i.value[0].x || "t" != i.value[1] || !n.next().done);
    } catch (e) {
      return !1;
    }
  }()) return e;

  f.initSymbol(), f.initSymbolIterator();
  var a = new WeakMap();
  i.prototype.set = function (e, t) {
    var r = n(this, e);
    return r.list || (r.list = this.data_[r.id] = []), r.entry ? r.entry.value = t : (r.entry = {
      next: this.head_,
      previous: this.head_.previous,
      head: this.head_,
      key: e,
      value: t
    }, r.list.push(r.entry), this.head_.previous.next = r.entry, this.head_.previous = r.entry, this.size++), this;
  }, i.prototype.delete = function (e) {
    return !(!(e = n(this, e)).entry || !e.list) && (e.list.splice(e.index, 1), e.list.length || delete this.data_[e.id], e.entry.previous.next = e.entry.next, e.entry.next.previous = e.entry.previous, e.entry.head = null, this.size--, !0);
  }, i.prototype.clear = function () {
    this.data_ = {}, this.head_ = this.head_.previous = t(), this.size = 0;
  }, i.prototype.has = function (e) {
    return !!n(this, e).entry;
  }, i.prototype.get = function (e) {
    return (e = n(this, e).entry) && e.value;
  }, i.prototype.entries = function () {
    return r(this, function (e) {
      return [e.key, e.value];
    });
  }, i.prototype.keys = function () {
    return r(this, function (e) {
      return e.key;
    });
  }, i.prototype.values = function () {
    return r(this, function (e) {
      return e.value;
    });
  }, i.prototype.forEach = function (e, t) {
    for (var r, n = this.entries(); !(r = n.next()).done;) {
      r = r.value, e.call(t, r[1], r[0], this);
    }
  }, i.prototype[Symbol.iterator] = i.prototype.entries;
  var o = 0;
  return i;
}, "es6", "es3"), f.assign = "function" == typeof Object.assign ? Object.assign : function (e, t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = arguments[r];
    if (n) for (var i in n) {
      f.owns(n, i) && (e[i] = n[i]);
    }
  }

  return e;
}, f.polyfill("Object.assign", function (e) {
  return e || f.assign;
}, "es6", "es3");
var r = this;
"object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (r = r || self, r.FastestValidator = t());